<template>
  <v-container class="impersonate-form" max-width="400">
    <v-card>
      <v-card-title>Innskrá sem notandi</v-card-title>
      <v-card-text>
        <v-form @submit.prevent="submit" ref="formRef">
          <v-text-field
            v-model="ssn"
            label="Kennitala"
            :rules="[validateSsn]"
            maxlength="10"
            required
          />
          <v-btn
            type="submit"
            color="primary"
            :loading="loading"
            :disabled="loading"
            class="mt-4"
          >
            Innskrá
          </v-btn>
        </v-form>
        <v-alert v-if="error" type="error" class="mt-3">
          {{ errorMessage }}
        </v-alert>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import useImpersonate from '@/composables/useImpersonate'

const ssn = ref('')
const formRef = ref()

const { impersonate, error, loading } = useImpersonate()

const validateSsn = (value: string) => {
  if (!/^\d{10}$/.test(value)) return 'Kennitala þarf að vera 10 tölustafir'
  return true
}

const errorMessage = computed(() => {
  return error.value?.response?.data || 'Villa kom upp við innskráningu.'
})

const submit = async () => {
  const isValid = await formRef.value.validate()
  if (!isValid.valid) return

  await impersonate({ impersonateSsn: ssn.value })
}
</script>

<style scoped>
.impersonate-form {
  margin-top: 150px;
}
</style>
